import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import dataReducer, { DataReducers } from "@tCooneyBrothers/Store/Data/DataReducer";

(reducers as any).cbData = dataReducer;

type Reducers = {
    cbData: typeof dataReducer;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
